import Tags from '../components/tags/tag'

export default {
  Tags
}



// WEBPACK FOOTER //
// ./src/app/professional/record/registration/resources/components.js